import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {Card, CardHeader, CardContent,CardActions } from '@material-ui/core';
import Button from './Button';
import Typography from '@material-ui/core/Typography'
import { FormattedMessage } from 'react-intl';
import { withNavigation } from '../actions/navigation';

/**
 * Error page, mainly used for "not found", with optionnal message
 */

const styles = theme => ({
});

class GenericNotFound extends React.Component {
  
  render() {
    
    const { 
      message,
      navigateToHomepage,
      title="Page not found"
    } = this.props;
      
    return (
      <Card>
        <CardHeader title={
          <Typography variant="h5">
            {title}
          </Typography>
        }
        />
        {message && (
          <CardContent>
            {message}
          </CardContent>
        )}
        <CardActions>
          <Button 
            variant="contained" 
            onClick={navigateToHomepage} 
            color="primary"            
          >
            <FormattedMessage id='error.page.backToYourAccount.button' />
          </Button>
        </CardActions>
      </Card>
    );

  }
};

GenericNotFound.propTypes = {
  classes: PropTypes.object.isRequired,
  navigateToHomepage: PropTypes.func.isRequired,
};

export default withStyles(styles)(
  withNavigation( 
    GenericNotFound
  )
);


// WEBPACK FOOTER //
// ./src/components/GenericNotFound.js